export const coerceToNull = <T>(val?: T): T | null => {
	if (val === undefined) {
		return null;
	}

	return val;
};

export const getMaybeUndefined = <T, V>(
	val: T | undefined,
	fallbackVal: V,
): T | V => {
	if (val === undefined) {
		return fallbackVal;
	}

	return val;
};

export const cond = (...pCPairs: Array<any>) => {
	const pCPair = pCPairs.find(([predicate, _]) => predicate());
	const [, consequent] = pCPair || [null, null];
	return consequent;
};

export const reverse = <T>(coll: Array<T>) =>
	coll.reduce((res: Array<T>, curVal: T) => [curVal, ...res], []);

export const partition =
	(n: number) =>
	(step: number) =>
	<T>(coll: Array<T>): Array<Array<T>> => {
		const p = coll.slice(0, n);

		if (n === p.length) {
			return [p, ...partition(n)(step)(coll.slice(step))];
		}

		return [];
	};

export const currency = (val: number): string => {
	return `$${val.toFixed(2)}`;
};

export const PromiseAllSequential = <T>(fn: Function, coll: Array<T> = []) => {
	return coll.reduce(async (promiseChain, currentInput): Promise<any> => {
		return promiseChain.then(async (chainResults) => {
			const currentResult = await fn(currentInput);
			return [...chainResults, currentResult];
		});
	}, Promise.resolve([]));
};
